import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import Card from "@mui/material/Card";
import { Button, CircularProgress } from "@mui/material";
import {
  userSelector,
  updateDietChartSettings,
  getDietChartSettings,
  clearState,
} from "store/features/authSlice";
import { InputOption } from "utils/common";
import Createable from "containers/Select";
import { toast } from "react-toastify";

const DietChartSettingsNew = () => {
  const dispatch = useDispatch();
  const { uid, dietChartSettings, isSuccess, message, isError } =
    useSelector(userSelector);
  const [selectedOption, setSelectedOption] = useState([]);
  const [loadingSave, setLoadingSave] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const dietChartOptions = [
    {
      value: "showDayCalorie",
      label: "Show Total Calories for the day",
    },
    {
      value: "showCalorieColumn",
      label: "Show Calorie column in diet chart",
    },
    {
      value: "showTimeCalorie",
      label: "Show Total Calories for the time",
    },
    {
      value: "showDaySugar",
      label: "Show Total Sugar for the day",
    },
    // {
    //   value: "showSugarColumn",
    //   label: "Show Sugar column in diet chart",
    // },
    {
      value: "showTimeSugar",
      label: "Show Total Sugar for the time",
    },
    {
      value: "showDayFat",
      label: "Show Total Fat for the day",
    },
    // {
    //   value: "showFatColumn",
    //   label: "Show Fat column in diet chart",
    // },
    {
      value: "showTimeFat",
      label: "Show Total Fat for the time",
    },
    {
      value: "showDayCarb",
      label: "Show Total Carb for the day",
    },
    // {
    //   value: "showCarbColumn",
    //   label: "Show Carb column in diet chart",
    // },
    {
      value: "showTimeCarb",
      label: "Show Total Carb for the time",
    },
    {
      value: "showDayProtein",
      label: "Show Total Protein for the day",
    },
    // {
    //   value: "showProteinColumn",
    //   label: "Show Protein column in diet chart",
    // },
    {
      value: "showTimeProtein",
      label: "Show Total Protein for the time",
    },
  ];
  useEffect(() => {
    dispatch(getDietChartSettings({ uid }));
  }, [dispatch, uid]);

  useEffect(() => {
    if (dietChartSettings) {
      const selectedValues = dietChartOptions.filter(
        (option) => dietChartSettings[option.value]
      );
      setSelectedOption(selectedValues);
    }
  }, [dietChartSettings]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     dispatch(clearState());
  //     toast.success(message);
  //   }
  //   if (isError) {
  //     dispatch(clearState());
  //     toast.error(message);
  //   }
  // }, [isSuccess, isError, message, dispatch]);

  const handleSaveSettings = async () => {
    setLoadingSave(true);
    const updatedSettings = dietChartOptions.reduce((item, option) => {
      const isSelected = selectedOption.some(
        (selected) => selected.value === option.value
      );
      item[option.value] = isSelected;
      return item;
    }, {});
    await dispatch(
      updateDietChartSettings({
        newDietChartSettings: updatedSettings,
        uid,
      })
    );
    await dispatch(getDietChartSettings({ uid }));
    setLoadingSave(false);
    setIsEdit(false);
  };

  return (
    <Card sx={{ height: "100%", width: "100%", overflow: "initial" }}>
      <SuiBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        padding={2}
        gap={1}
        width="100%"
      >
        <SuiTypography mb={1} variant="h6" textAlign="left">
          Diet Chart Settings
        </SuiTypography>
        <SuiBox width="100%">
          <Createable
            components={{
              Option: InputOption,
            }}
            value={selectedOption}
            disabled={!isEdit}
            options={dietChartOptions ?? []}
            style={{
              borderRadius: "0.5rem",
              fontSize: 14,
              zIndex: 999,
              borderColor: "#d2d6da",
              marginBottom: "1rem",
            }}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            inputStyle={{
              width: 190,
              height: "1.800rem",
              borderRadius: "0.5rem",
            }}
            placeholder="Diet Chart Settings"
            onChange={(selectedOption) => {
              if (Array.isArray(selectedOption)) {
                setSelectedOption(selectedOption);
              }
            }}
          />
          {isEdit ? (
            <SuiButton
              component={Button}
              color="dark"
              variant="gradient"
              onClick={handleSaveSettings}
              fullWidth
            >
              {loadingSave ? (
                <>
                  Save &nbsp;
                  <CircularProgress color="white" size={"1rem"} />
                </>
              ) : (
                "Save"
              )}
            </SuiButton>
          ) : (
            <SuiButton
              component={Button}
              color="dark"
              variant="gradient"
              onClick={() => setIsEdit(true)}
              fullWidth
            >
              Edit
            </SuiButton>
          )}
        </SuiBox>
      </SuiBox>
    </Card>
  );
};

export default DietChartSettingsNew;
